document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.slider-d5');
    sliders.forEach(slider => {
    const slides = slider.querySelector('.slides-d5');
    const dots = slider.querySelectorAll('.dot-d5');
    let slideWidth = slider.offsetWidth;
    let currentIndex = 0;
    let isDragging = false;
    let startPosX = 0;
    let startPosY = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let movedBy = 0;
    let movedByY = 0;
    function setActiveDot(index) {
      if (dots.length === 0) return;
      dots.forEach(dot => dot.classList.remove('active'));
      dots[index].classList.add('active');
    }
    function setSlidePosition() {
      slides.style.transition = 'transform 0.3s ease';
      slides.style.transform = `translateX(${-currentIndex * slideWidth}px)`;
    }
    function getPosition(event) {
      return event.type.includes('mouse')
        ? { x: event.pageX, y: event.pageY }
        : { x: event.touches[0].clientX, y: event.touches[0].clientY };
    }
    function startDrag(event) {
      isDragging = true;
      const position = getPosition(event);
      startPosX = position.x;
      startPosY = position.y;
      currentTranslate = prevTranslate;
      slides.style.transition = 'none';
      movedBy = 0;
      movedByY = 0;
    }
    function drag(event) {
      if (!isDragging) return;
      const position = getPosition(event);
      movedBy = position.x - startPosX;
      movedByY = position.y - startPosY;
      if (Math.abs(movedBy) > Math.abs(movedByY)) {
        if (event.type.includes('touch')) {
          event.preventDefault(); 
        }
        let nextTranslate = currentTranslate + movedBy;
        const maxNegativeTranslate = -((dots.length ? dots.length : slides.children.length) - 1) * slideWidth;
        if (nextTranslate > 0) {
          nextTranslate = 0;
        } else if (nextTranslate < maxNegativeTranslate) {
          nextTranslate = maxNegativeTranslate; 
        }
        slides.style.transform = `translateX(${nextTranslate}px)`;
      }
    }
    function endDrag() {
      if (!isDragging) return;
      isDragging = false;
      if (Math.abs(movedBy) > Math.abs(movedByY)) {
        if (movedBy < -30 && currentIndex < (dots.length ? dots.length - 1 : slides.children.length - 1)) {
          currentIndex++;
        } else if (movedBy > 30 && currentIndex > 0) {
          currentIndex--;
        }
      }
      setSlidePosition();
      setActiveDot(currentIndex);

      prevTranslate = -currentIndex * slideWidth;

      if (Math.abs(movedBy) < 10 && Math.abs(movedByY) < 10) {
        const url = slides.dataset.url;
        if (url) {
          window.location.href = url;
        }
      }
    }
    if (dots.length > 0) {
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          currentIndex = index;
          setSlidePosition();
          setActiveDot(currentIndex);
          prevTranslate = -currentIndex * slideWidth;
        });
      });
    }
    slides.addEventListener('mousedown', startDrag);
    slides.addEventListener('mousemove', drag);
    slides.addEventListener('mouseup', endDrag);
    slides.addEventListener('mouseleave', endDrag);
    slides.addEventListener('touchstart', startDrag, { passive: true }); 
    slides.addEventListener('touchmove', drag, { passive: false });
    slides.addEventListener('touchend', endDrag);
    window.addEventListener('resize', () => {
      slideWidth = slider.offsetWidth;
      setSlidePosition();
    });
    setActiveDot(0);
    setSlidePosition();
  });
});
